import { useEffect } from "react";
import { CheckCircle, Info, WarningCircle, X } from "@phosphor-icons/react";
import { useToastStore, type Toast } from "../../stores/toastStore";
import styles from "./ToastHost.module.css";

const ICONS = {
  success: CheckCircle,
  info: Info,
  error: WarningCircle,
} as const;

const AUTO_DISMISS_MS = 2000;

function ToastItem({ toast }: { toast: Toast }) {
  const dismiss = useToastStore((s) => s.dismiss);
  const Icon = ICONS[toast.variant];

  useEffect(() => {
    const timer = setTimeout(() => dismiss(toast.id), AUTO_DISMISS_MS);
    return () => clearTimeout(timer);
  }, [toast.id, dismiss]);

  return (
    <div
      className={[styles.toast, styles[toast.variant]].join(" ")}
      role="status"
    >
      <Icon
        className={styles.icon}
        size={20}
        weight="fill"
        aria-hidden="true"
      />
      <span className={styles.message}>{toast.message}</span>
      <button
        type="button"
        className={styles.close}
        aria-label="Dismiss notification"
        onClick={() => dismiss(toast.id)}
      >
        <X size={14} weight="bold" />
      </button>
    </div>
  );
}

export function ToastHost() {
  const toasts = useToastStore((s) => s.toasts);

  return (
    <div className={styles.host} aria-live="polite">
      {toasts.map((toast) => (
        <ToastItem key={toast.id} toast={toast} />
      ))}
    </div>
  );
}
